import React, { useState, useEffect } from "react";
// import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import axiosCommercial from "../../../Redux/axios/AxiosCommercial";
import {
  setCommercialQuickQuotes,
  setCommercialErrQuotes,
  setQuickQuotePost,
  getComQuickQuotePost,
} from "../../../Redux/actions/CommercialSlice";
import { Button, Form, DatePicker, message } from "antd/lib";
import moment from "moment";

export default function CommerPrevpolexp({ setisModalExp, CommerDetail }) {
  const dispatch = useDispatch();
  const auth = CommerDetail?.commercialnum;
  const QuickQuotePost = useSelector(getComQuickQuotePost);
  const [QuotePost, setQuotePost] = useState(QuickQuotePost);
  const [loading, setLoading] = useState(false);

  const onFinish = (data) => {
    console.log("product data", data);
    // console.log("dateString",data.registrationDate)
    const updatedQuotePost = {
      ...QuotePost,
      previousPolicyExpiryDate: moment(data.previousPolicyExpiryDate).format(
        "YYYY-MM-DD"
      ),
    };
    console.log(updatedQuotePost);
    setLoading(true);
    axiosCommercial
      .post(
        `v2/commercial_insurances/${auth?.commercial_insurance_id}/quick_quotes`,
        updatedQuotePost
      )
      .then((res) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          //console.log("data-----------------",data)
          const errData = data?.filter(
            (item) => "status" in item && item.status === "failed"
          );
          dispatch(setCommercialErrQuotes(errData));
          const filteredData = data?.filter(
            (item) => "status" in item && item.status === "success"
          );
          const updatedData = filteredData?.map((item) => ({
            ...item,
            IsGst: true,
          }));
          dispatch(setCommercialQuickQuotes(updatedData));
          //console.log(data)
          //dispatch(quick_quotes_Bike(data));
          dispatch(setQuickQuotePost(updatedQuotePost));
          setLoading(false);
          setisModalExp(false);
          // } else {
          // setLoading(false)
          // message.error(res.data.error.validationMessages.join(","));
          // }
        }
      })
      .catch((err) => {
        console.log(err.response.data.error);
        setLoading(false);
        message.error(err.response.data.error);
      });
  };
  return (
    <>
      <Form onFinish={onFinish} layout="vertical" requiredMark={false}>
        <Form.Item
          //className="form-item-bg"
          name="previousPolicyExpiryDate"
          label="Select Policy Expiry Date"
          rules={[
            {
              required: true,
              message: "Please select Date",
            },
          ]}
          initialValue={moment(QuickQuotePost.previousPolicyExpiryDate)}
        >
          <DatePicker
            style={{ width: "100%", padding: "8px" }}
            // disabledDate={disabledDate}
            // onChange={handleDateChange}
            format="YYYY-MM-DD"
            placeholder="Select Expiry Date"
          />
        </Form.Item>
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            htmlType="submit"
            className="update-qut-button"
            loading={loading}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
